import { view } from "@risingstack/react-easy-state";
import { IconFilter } from "@tine/designsystem-icons/sharp";
import { Accordion } from "@tine/designsystem-ui-react";
import { useMemo, useState } from "react";
import type { FilterSettings, LegalFilterKey, Product } from "../../common/types/productTypes";

import productStore from "../../stores/product/productStore";
import Button from "../Button";
import Modal from "../Modal";

import FilterChips from "./FilterChips";

type FilterSelectionOptionsProps = {
   products: Product[];
   filters: FilterSettings[];
   onFilterChange: (e: React.ChangeEvent<HTMLInputElement>, field: LegalFilterKey, value: string, isRadio: boolean) => void;
};

const FilterSelectionOptionsMobile = ({ products, filters }: FilterSelectionOptionsProps) => {
   const [open, setOpen] = useState<boolean>(false);
   const [openField, setOpenField] = useState<string>(filters[0]?.field || "");

   const filteredProducts = useMemo(() => productStore.filterWithActiveFilters(products), [products, productStore.activeFilters]);

   const handleButtonClick = () => {
      setOpen(!open);
   };
   const productCount = filteredProducts.length;
   const productText = productCount === 1 ? "produkt" : "produkter";
   const footer = (
      <Button size="full" onClick={() => setOpen(false)}>
         Vis {productCount} {productText}
      </Button>
   );

   const modalStyle = "!tw-w-[100vw] !tw-h-[100vh] tw-m-[-1rem] !tw-max-h-[100vh] !tw-rounded-none";
   return (
      <div>
         <Button size="full" onClick={handleButtonClick} icon={<IconFilter />}>
            Filter
         </Button>
         <Modal
            className={modalStyle}
            footer={footer}
            name="filterModal"
            size="2xl"
            title="Velg filtere"
            isOpen={open}
            onClose={() => setOpen(false)}
         >
            <div className="tw-size-full">
               {filters.map((filter) => (
                  <Accordion
                     label={filter.name}
                     key={filter.field}
                     isOpen={openField === filter.field}
                     onOpenChange={(isOpen) => (isOpen ? setOpenField(filter.field) : setOpenField(""))}
                  >
                     <div className="tw-flex tw-flex-wrap tw-gap-1">
                        <FilterChips filterSettings={filter} />
                     </div>
                  </Accordion>
               ))}
            </div>
         </Modal>
      </div>
   );
};

export default view(FilterSelectionOptionsMobile);
